<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>권한 관리</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          운영자
        </li>
        <li class="breadcrumb-item">
          <a href="/sso/roleList">권한 관리</a>
        </li>
      </ol>
    </div>
    <!-- 검색 -->
    <div class="card card-default">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색-->

    <!-- 목록 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right">
          <b-button @click="goDetail(0)" class="btn btn-xs btn-outline-info mr-2 py-1 px-3" variant="outline-primary">
            등록
          </b-button>
        </div>
        <ShowCounter label="Show" class="ml-1 mt-2" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td width="4%" class="text-center">No</td>
            <td width="20%" @click="localSort.sort('roleNm');" class="text-center">권한등급명<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td width="10%" @click="localSort.sort('admCount');" class="text-center">권한이용인원<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td width="7%" class="text-center">사용여부</td>
            <td width="15%" @click="localSort.sort('updDt');" class="text-center">수정일시<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="localSort.sort('roleDesc');" class="text-center">비고<em class="fa-2s mr-2 fas fa-sort"></em></td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center">
            <td colspan="6">No matching records</td>
          </tr>
          <tr v-for="(item, index) in data.list" :key="index">
            <td class="align-middle text-center" @click="goDetail(item.roleSeq)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
            <td class="align-middle text-center" @click="goDetail(item.roleSeq)">{{ item.roleNm }}</td>
            <td class="align-middle text-center" @click="goDetail(item.roleSeq)">{{ item.admCount }}</td>
            <td class="align-middle text-center" @click="goDetail(item.roleSeq)">{{ useYnOption.getText(item.useYn) }}</td>
            <td class="align-middle text-center" @click="goDetail(item.roleSeq)">{{ item.updDt }}</td>
            <td class="align-middle text-center" @click="goDetail(item.roleSeq)">{{ item.roleDesc }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)"
                      @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>
</template>
<script>
import store from "@/store/index";
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount, onUpdated} from '@vue/composition-api'
import {getSsoAdmList, getSsoAdmItem, getSsoRoleList, saveSsoAdm, deleteSsoAdm} from "@/api/sso/SsoAdmApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject, useYnOption, acntStatCd, ValueTexts} from "@/utils/Constants";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

//cfdbe2
export default {
  components: {SchText, ShowCounter, Pagenation, Loading},
  setup(props, {root}) {
    const modalLoading = ref(false);
        
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject);

    const schOptions = [{value: 'roleNm', text: '권한등급명'}, {value: 'roleDesc', text: '비고'}]
    data.schOptions = schOptions // 검색 type 선택

    const retVals = {
      modalLoading,
      useYnOption,
      data,
      ...methods(),
      dataAction : new TableActionClass(data),
      localSort: root.$_localSort
    }
    onMounted(async () => {
      if (store.state.params.name == 'ssoRoleList') {
        retVals.data.params = store.state.params.data;
        store.commit('setParams', {name:'', data:undefined});
      }
      await retVals.search();
    });

    return retVals;
  },
}

function methods() {

  // 목록
  async function search(page) {

    if (!isNaN(page)) {
      this.data.params.page = page;
    }

    this.modalLoading = true;
    const result = await getSsoRoleList(this.data.params);
    this.modalLoading = false;
    this.data.list = result.data;
    this.data.count = result.count;
    this.localSort.set(this.data.list);
  }

  // 상세
  async function goDetail(roleSeq) {
    this.$store.commit('setParams', {name:'ssoRoleList', data:this.data.params});
    this.$router.push({name:'ssoRoleDetail', params:{roleSeq:roleSeq}});
  }

  // 초기화
  async function reset() {
    this.dataAction.clear();
  }

  return {search, goDetail, reset}
}
</script>